"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kendo_intl_1 = require("@telerik/kendo-intl");
exports.load = kendo_intl_1.load;
//# sourceMappingURL=coreExports.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-intl/dist/npm/coreExports.js
// module id = 6609
// module chunks = 0